import classnames from 'classnames';
import React from 'react';
import fileIconRedesign from '../../icons/file2.svg';
import { FileData } from '../models';
import styles from './dataFileBox.module.scss';

interface DataFileBoxProps {
  fileData: FileData;
  actions?: JSX.Element;
  className?: string;
}

const DataFileBox = ({ fileData, actions, className }: DataFileBoxProps) => {
  return (
    <div
      className={classnames(
        styles.fileInfoContainer,
        className,
        styles.fileInfoContainerRedesign,
        'data-file-box--datafile-info-container'
      )}
    >
      <img src={fileIconRedesign} alt="fileIcon"></img>
      <div className={styles.fileInfo}>
        <p
          className={classnames(
            styles.fileText,
            'text-primary-dark',
            'data-file-box--file-name'
          )}
        >
          {fileData?.name}
        </p>
        <p
          className={classnames(
            styles.fileText,
            styles.fileSize,
            'text-light2'
          )}
        >
          {fileData?.size}
        </p>
      </div>
      {actions}
    </div>
  );
};

export default DataFileBox;
